import { render, staticRenderFns } from "./coinspaid.vue?vue&type=template&id=22476d4e&scoped=true"
import script from "./coinspaid.vue?vue&type=script&lang=js"
export * from "./coinspaid.vue?vue&type=script&lang=js"
import style0 from "./coinspaid.vue?vue&type=style&index=0&id=22476d4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22476d4e",
  null
  
)

export default component.exports